import {getApiUrl} from 'api/urls'
import {apiFetch} from 'lib/fetch'
import type {Act, ListAct} from 'types/department'

/* ACTS */
export const list = () =>
  apiFetch.get<ListAct[]>(getApiUrl('acts'), {simple: 'true'})

export const show = (id: number) => apiFetch.get<Act>(getApiUrl('acts', id))
